import { PageSEO } from "@/components/seo/PageSEO";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { StatsSection } from "@/components/landing/StatsSection";
import { CallToActionSection } from "@/components/landing/CallToActionSection";
import { RootLayout } from "@/components/layout/RootLayout";

/**
 * Renders the landing page for the TellerWand financial management platform.
 * @example
 * Landing()
 * React component displaying Helmet metadata and page sections.
 * @returns {JSX.Element} The JSX for the landing page layout.
 * @description
 *   - The Helmet component sets up SEO-related metadata for search engines.
 *   - Incorporates multiple sections like header, main content, and footer.
 *   - Responsive design adjustments cater to different screen sizes.
 *   - Utilizes React components such as Link for navigation and Logo for branding.
 */
export default function Landing() {
  return (
    <>
      <PageSEO page="home" />

      <RootLayout>
        <div className="bg-gradient-to-br from-orange-50 via-white to-orange-100">
          <HeroSection />
          <FeaturesSection />
          <StatsSection />
          <CallToActionSection />
        </div>
      </RootLayout>
    </>
  );
}
